import SettingsProfilePage from '@/components/pages/Settings/account/SettingsProfilePage/SettingsProfilePage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$workspaceName/$environment/account-settings/profile')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SettingsProfilePage />
}
